import { z } from 'zod'
import { ASCEND_LOCATIONS_QUERY } from '../graphql'
import { SAVE_ASCEND_INTEGRATION } from '../ops-graphql'
import { PmsWorkspaceWizard, type PmsWizardConfig } from './PmsWorkspaceWizard'
import type { LocationType } from 'app/types/entities'
import { gqlQuery } from 'app/lib/graphqlClient'
import { gqlOpsMutation } from 'app/lib/opsGraphqlClient'

const config: PmsWizardConfig = {
  name: `Ascend`,
  setupAction: `/api/integrations/setup/ascend`,
  fields: [{ name: `ascendOrgId`, label: `Ascend Org ID` }],
  schema: z.object({
    ascendOrgId: z.string().min(1, { message: `Ascend Org ID is required` }),
  }),
  loadErrorMessage: `Could not load locations from Ascend. Confirm the Ascend Organization ID, then try again.`,
  loadRemoteEntities: async () => {
    const result = await gqlQuery(ASCEND_LOCATIONS_QUERY, {}, { suppressErrorToast: true })
    const entities = result.data?.integrationOptions.ascendLocations
    return entities ? { entities } : { errorMessage: result.error?.message }
  },
  saveMapping: async (ascendLocationId, locationId) => {
    const result = await gqlOpsMutation(SAVE_ASCEND_INTEGRATION, { locationId, ascendLocationId })
    const saved = result.data?.saveAscendIntegration
    return { success: !!saved?.success, error: saved?.error ?? result.error }
  },
  isLocationLinked: (location: LocationType, remoteId: string) => location.ascendLocationId === remoteId,
  isLocationUsed: (location: LocationType) => !!location.ascendLocationId,
}

export function AscendWorkspaceModalForm({
  onIntegrationChanged,
  currentValues,
  onBack,
}: {
  onIntegrationChanged: () => void
  currentValues?: {
    ascendOrgId?: string
  }
  /** Wizard back target: overrides returning to the workspace integration picker. */
  onBack?: () => void
}) {
  return (
    <PmsWorkspaceWizard
      config={config}
      onIntegrationChanged={onIntegrationChanged}
      currentValues={currentValues}
      onBack={onBack}
    />
  )
}
